import { render } from "./breadcrumbs.vue?vue&type=template&id=2a140446"
import script from "./breadcrumbs.vue?vue&type=script&lang=js"
export * from "./breadcrumbs.vue?vue&type=script&lang=js"

import "./breadcrumbs.vue?vue&type=style&index=0&id=2a140446&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__